/* OTX landing sections — shared runtime (DL Media) */
(function(){
  if (window.__otxl) return; window.__otxl = true;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var qs = new URLSearchParams(location.search);
  var clamp = function(v, a, b){ return Math.max(a, Math.min(b, v)); };
  var esc = function(s){ var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; };
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  var money = function(c){ try { return new Intl.NumberFormat('en-US', {style:'currency', currency: cur}).format(c/100).replace(/\.00$/, ''); } catch(e){ return '$' + (c/100).toFixed(2); } };
  var src = ((qs.get('utm_medium') || '') + ' ' + (qs.get('utm_source') || '')).toLowerCase();
  var isSms = /sms|text|attentive|postscript/.test(src);

  var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, {rootMargin:'0px 0px -10% 0px', threshold:.05});

  var heroes = [], pins = [], marquees = [], joins = [];

  function initRoot(root){
    if (!root || root.dataset.otxlReady) return;
    root.dataset.otxlReady = '1';
    root.querySelectorAll('.otxl-in, .otxl-card').forEach(function(el){ io.observe(el); });
    if (isSms) root.querySelectorAll('[data-sms-pill]').forEach(function(p){ p.hidden = false; });

    var hero = root.querySelector('[data-hero]');
    if (hero) {
      heroes.push({ el: hero, media: hero.querySelector('.otxl-hero__media') });
      var h1 = hero.querySelector('[data-headline]');
      var hl = qs.get('hl');
      if (h1 && hl && hl.length < 60) h1.textContent = hl;
      if (h1) splitHeadline(h1, hero);
      initCountdown(hero.querySelector('[data-countdown]'));
    }

    var offer = root.querySelector('[data-offer]');
    if (offer) initOffer(offer);

    var pin = root.querySelector('[data-pin]');
    if (pin) {
      var p = { el: pin, track: pin.querySelector('[data-pin-track]'), bar: pin.querySelector('[data-pin-bar]'), now: pin.querySelector('[data-pin-now]'), dist: 0, last: -1 };
      p.items = p.track ? p.track.querySelectorAll('.otxl-design:not(.otxl-design--end)') : [];
      pins.push(p); sizePin(p);
    }

    root.querySelectorAll('[data-marquee]').forEach(function(el){
      marquees.push({ el: el, dir: +el.dataset.marquee || 1, speed: parseFloat(el.dataset.speed || '1'), x: 0, w: el.scrollWidth / 2 });
    });

    root.querySelectorAll('[data-count]').forEach(function(cnt){
      var target = parseFloat(cnt.dataset.count) || 0;
      if (reduce || target <= 0) return;
      cnt.textContent = '0';
      var cio = new IntersectionObserver(function(es){
        if (!es[0].isIntersecting) return; cio.disconnect();
        var t0 = performance.now();
        (function f(now){ var pr = Math.min(1, (now - t0)/1600); cnt.textContent = Math.round(target * (1 - Math.pow(1 - pr, 4))); if (pr < 1) requestAnimationFrame(f); })(t0);
      }, {threshold:.6});
      cio.observe(cnt);
    });

    var join = root.querySelector('.otxl-join');
    if (join) joins.push({ el: join, x: join.querySelector('.otxl-x--join') });

    var sticky = root.querySelector('[data-sticky]');
    if (sticky) initSticky(sticky);

    root.querySelectorAll('a[href^="#"]').forEach(function(a){
      a.addEventListener('click', function(e){
        var id = a.getAttribute('href'); if (id.length < 2) return;
        var t = document.querySelector(id); if (!t) return;
        e.preventDefault(); t.scrollIntoView({behavior: reduce ? 'auto' : 'smooth', block:'start'});
      });
    });
  }

  function splitHeadline(h1, hero){
    var i = 0;
    var wrap = function(node){
      Array.prototype.slice.call(node.childNodes).forEach(function(ch){
        if (ch.nodeType === 3) {
          var frag = document.createDocumentFragment();
          ch.textContent.split(/(\s+)/).forEach(function(part){
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span'); w.className = 'w';
            var inner = document.createElement('span'); inner.textContent = part; inner.style.setProperty('--d', (0.12 + i++ * 0.07) + 's');
            w.appendChild(inner); frag.appendChild(w);
          });
          node.replaceChild(frag, ch);
        } else if (ch.nodeType === 1 && ch.classList.contains('otxl-x')) {
          ch.style.setProperty('--xd', (0.25 + i * 0.07) + 's'); i++;
        } else if (ch.nodeType === 1) { wrap(ch); }
      });
    };
    wrap(h1);
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ h1.classList.add('is-go'); }); });
    var x = h1.querySelector('.otxl-x');
    if (x && !reduce) x.addEventListener('animationend', function(){ hero.classList.add('is-hit'); setTimeout(function(){ hero.classList.remove('is-hit'); }, 400); }, {once:true});
  }

  function initCountdown(cd){
    if (!cd) return;
    var end = Date.parse(cd.dataset.end || '');
    if (!end || end <= Date.now()) return;
    cd.hidden = false;
    var pad = function(n){ return String(n).padStart(2,'0'); };
    var els = { d: cd.querySelector('[data-d]'), h: cd.querySelector('[data-h]'), m: cd.querySelector('[data-m]'), s: cd.querySelector('[data-s]') };
    var iv;
    var tick = function(){
      var t = Math.max(0, end - Date.now());
      els.d.textContent = pad(Math.floor(t/864e5)); els.h.textContent = pad(Math.floor(t/36e5)%24);
      els.m.textContent = pad(Math.floor(t/6e4)%60); els.s.textContent = pad(Math.floor(t/1e3)%60);
      if (t <= 0) { cd.hidden = true; clearInterval(iv); }
    };
    tick(); iv = setInterval(tick, 1000);
  }

  function initOffer(offer){
    var code = (qs.get('code') || qs.get('discount') || offer.dataset.code || '').trim();
    var codeEl = offer.querySelector('[data-code-text]');
    var status = offer.querySelector('[data-offer-status]');
    if (code && codeEl) codeEl.textContent = code.toUpperCase();
    if (code && offer.dataset.autoapply === 'true' && !window.__otxlApplied) {
      window.__otxlApplied = true;
      fetch('/discount/' + encodeURIComponent(code), {credentials:'same-origin', redirect:'manual'}).then(function(){ if (status) status.textContent = 'Auto-applied at checkout'; }).catch(function(){});
    }
    offer.addEventListener('click', function(){
      var t = codeEl ? codeEl.textContent : code;
      var done = function(){ var prev = status.textContent; status.textContent = 'Copied'; setTimeout(function(){ status.textContent = prev; }, 1800); if (navigator.vibrate) navigator.vibrate(12); };
      if (navigator.clipboard) navigator.clipboard.writeText(t).then(done, done); else done();
    });
  }

  var stickyState = { heroOut: false, joinIn: false };
  function initSticky(sticky){
    var set = function(){ var on = stickyState.heroOut && !stickyState.joinIn; sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); var a = sticky.querySelector('a'); if (a) a.tabIndex = on ? 0 : -1; };
    var hero = document.querySelector('.otxl [data-hero]');
    var join = document.querySelector('.otxl-join');
    if (hero) new IntersectionObserver(function(es){ stickyState.heroOut = !es[0].isIntersecting; set(); }, {rootMargin:'-60% 0px 0px 0px'}).observe(hero);
    else stickyState.heroOut = true;
    if (join) new IntersectionObserver(function(es){ stickyState.joinIn = es[0].isIntersecting; set(); }).observe(join);
    set();
  }

  var desk = matchMedia('(min-width: 990px)');
  function sizePin(p){
    if (!p.track) return;
    if (desk.matches && !reduce) {
      p.el.classList.add('is-pinned'); p.track.style.transform = '';
      p.dist = Math.max(0, p.track.scrollWidth - innerWidth);
      p.el.style.height = (innerHeight + p.dist) + 'px';
    } else {
      p.el.classList.remove('is-pinned'); p.el.style.height = ''; p.track.style.transform = ''; p.dist = 0;
    }
  }
  function remeasure(){ pins.forEach(sizePin); marquees.forEach(function(m){ m.w = m.el.scrollWidth / 2; }); }
  addEventListener('resize', remeasure); addEventListener('load', remeasure);

  var lastY = scrollY, vel = 0;
  function loop(){
    var y = scrollY, dy = y - lastY; lastY = y; vel += (dy - vel) * 0.12;
    if (!reduce) {
      heroes.forEach(function(h){
        if (!h.media) return; var r = h.el.getBoundingClientRect();
        if (r.bottom > 0) h.media.style.transform = 'translate3d(0,' + (-r.top * 0.35).toFixed(1) + 'px,0) scale(' + (1 + Math.min(1, Math.max(0, -r.top / r.height)) * 0.08).toFixed(3) + ')';
      });
      marquees.forEach(function(m){
        if (!m.w) return;
        m.x -= m.dir * (0.6 * m.speed + Math.abs(vel) * 0.25 * m.speed) * (vel < -1 ? -1 : 1);
        if (m.x <= -m.w) m.x += m.w; if (m.x > 0) m.x -= m.w;
        m.el.style.transform = 'translate3d(' + m.x.toFixed(1) + 'px,0,0)';
      });
      pins.forEach(function(p){
        if (p.el.classList.contains('is-pinned') && p.dist > 0) {
          var r = p.el.getBoundingClientRect();
          var pr = clamp(-r.top / (r.height - innerHeight), 0, 1);
          p.track.style.transform = 'translate3d(' + (-pr * p.dist).toFixed(1) + 'px,0,0)';
          if (p.bar) p.bar.style.width = (pr * 100).toFixed(2) + '%';
          var idx = Math.min(p.items.length - 1, Math.floor(pr * p.items.length));
          if (idx !== p.last && p.now) { p.last = idx; p.now.textContent = String(idx + 1).padStart(2, '0'); }
        } else if (p.track && p.bar) {
          var mx = p.track.scrollWidth - p.track.clientWidth;
          p.bar.style.width = (mx > 0 ? p.track.scrollLeft / mx * 100 : 0) + '%';
        }
      });
      joins.forEach(function(j){
        if (!j.x) return; var r = j.el.getBoundingClientRect();
        if (r.top < innerHeight && r.bottom > 0) { var jp = 1 - r.top / innerHeight; j.x.style.transform = 'rotate(' + (jp * 40 - 20).toFixed(1) + 'deg) scale(' + (0.85 + jp * 0.2).toFixed(3) + ')'; }
      });
    }
    requestAnimationFrame(loop);
  }
  requestAnimationFrame(loop);

  var toast = document.createElement('div'); toast.className = 'otxl-toast'; toast.setAttribute('role', 'status'); toast.setAttribute('aria-live', 'polite');
  var sheet = document.createElement('dialog'); sheet.className = 'otxl-sheet'; sheet.setAttribute('aria-label', 'Choose options');
  sheet.innerHTML = '<form method="dialog" class="otxl-sheet__x"><button aria-label="Close"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg></button></form><div class="otxl-sheet__body"><div class="otxl-sheet__img" data-sheet-img></div><div class="otxl-sheet__info"><h3 data-sheet-title></h3><p class="otxl-sheet__price" data-sheet-price></p><div data-sheet-options></div><button type="button" class="otxl-btn otxl-btn--red otxl-btn--block" data-sheet-add disabled><span>Select a size</span></button><a class="otxl-sheet__pdp" data-sheet-pdp href="#">View full details</a></div></div>';
  var tt;
  var showToast = function(html){ toast.innerHTML = html; toast.classList.add('is-on'); clearTimeout(tt); tt = setTimeout(function(){ toast.classList.remove('is-on'); }, 3800); };
  var drawer = function(){ return document.querySelector('cart-drawer') || document.querySelector('cart-notification'); };
  var bump = function(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
      document.querySelectorAll('.cart-count-bubble span[aria-hidden], [data-cart-count]').forEach(function(el){ el.textContent = c.item_count; });
    }).catch(function(){});
  };
  function addToCart(id, btn){
    var d = drawer();
    var body = { items: [{ id: +id, quantity: 1 }] };
    if (d && d.getSectionsToRender) { body.sections = d.getSectionsToRender().map(function(s){ return s.id; }); body.sections_url = location.pathname; }
    if (btn) btn.classList.add('is-busy');
    return fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify(body) })
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
      .then(function(res){
        if (btn){ btn.classList.remove('is-busy'); btn.classList.add('is-done'); setTimeout(function(){ btn.classList.remove('is-done'); }, 1600); }
        if (navigator.vibrate) navigator.vibrate(15);
        var item = res.items ? res.items[0] : res;
        if (d && d.renderContents && res.sections) {
          try { res.id = item.id; res.key = item.key; d.classList.remove('is-empty'); d.renderContents(res); return; } catch(e){}
        }
        bump();
        showToast('<span>Added: ' + esc(item.product_title || 'item') + '</span><a href="/cart">View cart</a>');
      })
      .catch(function(err){
        if (btn) btn.classList.remove('is-busy');
        showToast('<span>' + esc((err && (err.description || err.message)) || 'Could not add to cart') + '</span>');
      });
  }

  var state = null, addBtn, addLbl;
  function findVariant(){ if (!state) return null; return state.p.variants.find(function(v){ return v.options.every(function(o, k){ return state.sel[k] === o; }); }) || null; }
  function syncSheet(){
    var v = findVariant();
    sheet.querySelectorAll('.otxl-opt').forEach(function(b){
      var k = +b.dataset.i, val = b.dataset.v;
      b.setAttribute('aria-pressed', state.sel[k] === val ? 'true' : 'false');
      var test = state.sel.slice(); test[k] = val;
      var any = state.p.variants.some(function(x){ return x.available && x.options.every(function(o, j){ return test[j] == null || test[j] === o; }); });
      b.classList.toggle('is-oos', !any);
    });
    if (v) {
      sheet.querySelector('[data-sheet-price]').innerHTML = money(v.price) + (v.compare_at_price > v.price ? ' <s style="opacity:.5;font-size:.8em">' + money(v.compare_at_price) + '</s>' : '');
      addBtn.disabled = !v.available;
      addLbl.textContent = v.available ? 'Add to cart / ' + money(v.price) : 'Sold out';
    } else {
      addBtn.disabled = true;
      var miss = state.sel.findIndex(function(s){ return s == null; });
      addLbl.textContent = 'Select ' + String(state.p.options[miss] || 'options').toLowerCase();
    }
  }
  function openSheet(p, card){
    state = { p: p, sel: p.options.map(function(){ return null; }) };
    p.options.forEach(function(_, k){ var vals = []; p.variants.forEach(function(v){ if (vals.indexOf(v.options[k]) < 0) vals.push(v.options[k]); }); if (vals.length === 1) state.sel[k] = vals[0]; });
    sheet.querySelector('[data-sheet-title]').textContent = p.title;
    sheet.querySelector('[data-sheet-pdp]').href = p.url;
    var img = card.querySelector('.otxl-card__media img');
    sheet.querySelector('[data-sheet-img]').innerHTML = img ? '<img src="' + esc(img.currentSrc || img.src) + '" alt="">' : '';
    var html = '';
    p.options.forEach(function(name, k){
      var vals = []; p.variants.forEach(function(v){ if (vals.indexOf(v.options[k]) < 0) vals.push(v.options[k]); });
      if (vals.length < 2) return;
      html += '<fieldset class="otxl-optgroup"><legend>' + esc(name) + '</legend><div class="otxl-opts">';
      vals.forEach(function(val){ html += '<button type="button" class="otxl-opt" data-i="' + k + '" data-v="' + esc(val).replace(/"/g, '&quot;') + '">' + esc(val) + '</button>'; });
      html += '</div></fieldset>';
    });
    sheet.querySelector('[data-sheet-options]').innerHTML = html;
    syncSheet();
    sheet.showModal();
  }

  function boot(){
    document.body.appendChild(toast); document.body.appendChild(sheet);
    addBtn = sheet.querySelector('[data-sheet-add]'); addLbl = addBtn.querySelector('span');
    sheet.addEventListener('click', function(e){
      var o = e.target.closest('.otxl-opt');
      if (o) { state.sel[+o.dataset.i] = o.dataset.v; syncSheet(); return; }
      if (e.target === sheet) sheet.close();
    });
    addBtn.addEventListener('click', function(){
      var v = findVariant(); if (!v) return;
      addBtn.disabled = true; addLbl.textContent = 'Adding';
      addToCart(v.id).then(function(){ sheet.close(); });
    });
    document.addEventListener('click', function(e){
      var b = e.target.closest('.otxl [data-quick-add]'); if (!b) return;
      e.preventDefault();
      var card = b.closest('.otxl-card');
      var data = card && card.querySelector('script[type="application/json"]');
      if (!data) return;
      var p = JSON.parse(data.textContent);
      if (p.variants.length === 1) addToCart(p.variants[0].id, b); else openSheet(p, card);
    });
    document.querySelectorAll('.otxl').forEach(initRoot);
    remeasure();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('shopify:section:load', function(e){
    var r = e.target.querySelector('.otxl');
    heroes = heroes.filter(function(h){ return document.contains(h.el); });
    pins = pins.filter(function(p){ return document.contains(p.el); });
    marquees = marquees.filter(function(m){ return document.contains(m.el); });
    joins = joins.filter(function(j){ return document.contains(j.el); });
    if (r) initRoot(r);
    remeasure();
  });
})();


/* ===== v4: logo X sprite ===== */
(function(){
  var put = function(){ if (document.getElementById('otxl-xp')) return; document.body.insertAdjacentHTML('afterbegin', '<svg width="0" height="0" style="position:absolute;overflow:hidden" aria-hidden="true"><defs><path id="otxl-xp" pathLength="1" d="M30.5 31.5Q49 32 63.5 34.5Q78 37 87.0 40.0Q96 43 96.5 44.0Q97 45 100.5 46.5Q104 48 105.5 50.0Q107 52 108.0 52.0Q109 52 109.0 51.0Q109 50 113.5 45.0Q118 40 119.0 40.0Q120 40 124.0 37.0Q128 34 133.0 32.5Q138 31 147.0 31.5Q156 32 156.0 33.5Q156 35 154.5 36.0Q153 37 150.5 41.5Q148 46 146.5 51.0Q145 56 145.5 64.5Q146 73 147.5 77.5Q149 82 150.5 84.0Q152 86 152.0 87.5Q152 89 153.5 92.0Q155 95 156.0 95.5Q157 96 165.0 112.0Q173 128 173.0 129.5Q173 131 175.0 134.0Q177 137 177.0 138.5Q177 140 179.0 143.0Q181 146 181.0 147.5Q181 149 182.5 151.0Q184 153 184.0 154.5Q184 156 185.5 158.0Q187 160 187.0 161.5Q187 163 188.5 165.0Q190 167 191.5 171.5Q193 176 194.0 175.5Q195 175 197.0 171.0Q199 167 199.0 165.5Q199 164 200.5 162.0Q202 160 202.0 158.5Q202 157 205.5 150.0Q209 143 209.0 141.5Q209 140 211.0 137.0Q213 134 213.0 132.5Q213 131 227.0 103.0Q241 75 242.0 69.5Q243 64 242.5 59.0Q242 54 241.0 50.5Q240 47 237.5 42.5Q235 38 234.0 37.5Q233 37 233.0 36.0Q233 35 232.0 34.5Q231 34 231.0 33.0Q231 32 240.0 31.5Q249 31 253.0 32.0Q257 33 262.5 36.0Q268 39 272.5 43.5Q277 48 278.0 50.0Q279 52 287.5 46.5Q296 41 307.5 38.0Q319 35 334.5 33.0Q350 31 367.0 31.5Q384 32 384.0 33.5Q384 35 375.5 38.5Q367 42 366.5 43.0Q366 44 362.0 46.0Q358 48 356.5 50.0Q355 52 354.0 52.0Q353 52 349.5 56.0Q346 60 344.0 61.0Q342 62 342.0 63.0Q342 64 336.0 70.0Q330 76 330.0 77.0Q330 78 324.0 86.0Q318 94 317.5 96.0Q317 98 315.0 100.0Q313 102 312.5 104.0Q312 106 310.0 108.0Q308 110 307.5 112.0Q307 114 305.0 116.0Q303 118 302.5 120.0Q302 122 300.0 124.0Q298 126 297.5 128.0Q297 130 295.0 132.0Q293 134 292.5 136.0Q292 138 290.0 140.0Q288 142 287.5 144.0Q287 146 285.0 148.0Q283 150 282.5 152.0Q282 154 281.0 154.5Q280 155 277.5 160.0Q275 165 273.0 167.0Q271 169 270.5 171.0Q270 173 268.0 175.0Q266 177 265.5 179.0Q265 181 264.0 181.5Q263 182 260.5 187.0Q258 192 256.0 194.0Q254 196 253.5 198.0Q253 200 251.0 202.0Q249 204 248.5 206.0Q248 208 246.0 210.0Q244 212 244.0 214.5Q244 217 247.0 221.0Q250 225 251.5 228.5Q253 232 254.0 232.5Q255 233 255.5 235.0Q256 237 259.0 240.5Q262 244 262.5 246.0Q263 248 265.0 250.0Q267 252 267.5 254.0Q268 256 270.0 258.0Q272 260 272.5 262.0Q273 264 275.0 266.0Q277 268 277.5 270.0Q278 272 280.0 274.0Q282 276 282.5 278.0Q283 280 286.0 283.5Q289 287 289.5 289.0Q290 291 292.0 293.0Q294 295 294.5 297.0Q295 299 297.0 301.0Q299 303 299.5 305.0Q300 307 303.0 310.5Q306 314 306.5 316.0Q307 318 310.0 321.5Q313 325 313.5 327.0Q314 329 317.0 332.5Q320 336 320.5 338.0Q321 340 322.0 340.5Q323 341 327.0 348.0Q331 355 332.5 356.0Q334 357 334.0 358.0Q334 359 342.5 368.0Q351 377 352.0 377.0Q353 377 356.5 380.5Q360 384 361.0 384.0Q362 384 364.0 386.0Q366 388 368.0 388.5Q370 389 370.5 390.0Q371 391 375.0 393.0Q379 395 383.0 396.0Q387 397 387.5 398.0Q388 399 380.0 400.0Q372 401 359.5 401.0Q347 401 338.0 400.0Q329 399 314.0 395.5Q299 392 298.0 391.0Q297 390 295.5 390.0Q294 390 292.0 388.5Q290 387 286.5 386.0Q283 385 281.5 383.5Q280 382 275.5 386.5Q271 391 264.0 394.5Q257 398 252.0 399.0Q247 400 241.0 400.0Q235 400 230.0 398.5Q225 397 224.5 395.5Q224 394 226.5 393.5Q229 393 231.0 391.0Q233 389 236.0 383.0Q239 377 238.5 367.0Q238 357 236.5 352.5Q235 348 233.5 346.0Q232 344 232.0 342.5Q232 341 230.0 338.0Q228 335 228.0 333.5Q228 332 226.0 329.0Q224 326 224.0 324.5Q224 323 222.5 321.0Q221 319 221.0 317.5Q221 316 219.0 313.0Q217 310 217.0 308.5Q217 307 215.0 304.0Q213 301 213.0 299.5Q213 298 211.0 295.0Q209 292 209.0 290.5Q209 289 202.5 276.0Q196 263 195.5 260.5Q195 258 194.0 258.0Q193 258 192.0 259.5Q191 261 191.0 262.5Q191 264 189.0 267.0Q187 270 187.0 271.5Q187 273 185.0 276.0Q183 279 183.0 280.5Q183 282 181.0 285.0Q179 288 179.0 289.5Q179 291 177.0 294.0Q175 297 175.0 298.5Q175 300 173.0 303.0Q171 306 171.0 307.5Q171 309 169.0 312.0Q167 315 167.0 316.5Q167 318 159.5 333.5Q152 349 150.0 355.5Q148 362 148.0 368.0Q148 374 149.0 377.5Q150 381 151.5 384.0Q153 387 156.0 390.0Q159 393 161.5 394.0Q164 395 163.5 396.0Q163 397 158.5 398.5Q154 400 144.0 399.5Q134 399 127.5 396.5Q121 394 120.5 393.0Q120 392 117.5 391.0Q115 390 112.0 386.5Q109 383 107.5 383.0Q106 383 98.5 387.0Q91 391 75.0 395.0Q59 399 49.5 400.0Q40 401 27.5 401.0Q15 401 7.5 400.0Q0 399 0.5 398.0Q1 397 9.5 393.5Q18 390 18.5 389.0Q19 388 21.0 387.5Q23 387 25.5 384.5Q28 382 29.0 382.0Q30 382 42.0 370.0Q54 358 54.0 357.0Q54 356 55.5 355.0Q57 354 57.0 353.0Q57 352 58.5 351.0Q60 350 60.0 349.0Q60 348 63.0 344.5Q66 341 66.5 339.0Q67 337 69.0 335.0Q71 333 71.5 331.0Q72 329 74.0 327.0Q76 325 76.5 323.0Q77 321 79.0 319.0Q81 317 81.5 315.0Q82 313 85.0 309.5Q88 306 88.5 304.0Q89 302 91.0 300.0Q93 298 93.5 296.0Q94 294 96.0 292.0Q98 290 98.5 288.0Q99 286 101.0 284.0Q103 282 103.5 280.0Q104 278 107.0 274.5Q110 271 110.5 269.0Q111 267 113.0 265.0Q115 263 115.5 261.0Q116 259 118.0 257.0Q120 255 120.5 253.0Q121 251 124.0 247.5Q127 244 127.5 242.0Q128 240 129.0 239.5Q130 239 131.5 235.5Q133 232 134.0 231.5Q135 231 135.0 230.0Q135 229 136.0 228.5Q137 228 137.5 226.0Q138 224 141.0 220.0Q144 216 144.0 214.5Q144 213 142.0 211.0Q140 209 139.5 207.0Q139 205 137.0 203.0Q135 201 134.5 199.0Q134 197 132.0 195.0Q130 193 129.5 191.0Q129 189 127.0 187.0Q125 185 124.5 183.0Q124 181 122.0 179.0Q120 177 119.5 175.0Q119 173 117.0 171.0Q115 169 114.5 167.0Q114 165 112.0 163.0Q110 161 109.5 159.0Q109 157 107.0 155.0Q105 153 104.5 151.0Q104 149 103.0 148.5Q102 148 100.5 144.5Q99 141 96.0 137.5Q93 134 92.5 132.0Q92 130 90.0 128.0Q88 126 87.5 124.0Q87 122 85.0 120.0Q83 118 82.5 116.0Q82 114 80.0 112.0Q78 110 77.5 108.0Q77 106 74.0 102.5Q71 99 70.5 97.0Q70 95 68.0 93.0Q66 91 65.5 89.0Q65 87 64.0 86.5Q63 86 61.0 82.0Q59 78 55.0 74.0Q51 70 51.0 69.0Q51 68 41.5 59.0Q32 50 31.0 50.0Q30 50 29.0 48.5Q28 47 24.5 45.5Q21 44 20.5 43.0Q20 42 11.5 38.5Q3 35 2.5 34.0Q2 33 3.0 32.5Q4 32 8.0 31.5Q12 31 30.5 31.5Z"/></defs></svg>'); };
  if (document.body) put(); else document.addEventListener('DOMContentLoaded', put);
})();

/* ===== v4: hero star field: finds the real bright specks in the hero photo and twinkles them ===== */
(function(){
  if (window.__otxlStars) return; window.__otxlStars = true;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function detect(img){
    var iw = img.naturalWidth, ih = img.naturalHeight; if (!iw) return null;
    var sc = Math.min(1, 520 / iw), sw = Math.max(1, Math.round(iw * sc)), sh = Math.max(1, Math.round(ih * sc));
    var c = document.createElement('canvas'); c.width = sw; c.height = sh;
    var x = c.getContext('2d', { willReadFrequently: true }), data;
    try { x.drawImage(img, 0, 0, sw, sh); data = x.getImageData(0, 0, sw, sh).data; } catch (e) { return null; }
    var L = new Float32Array(sw * sh);
    for (var i = 0; i < sw * sh; i++) L[i] = data[i*4] * .299 + data[i*4+1] * .587 + data[i*4+2] * .114;
    var out = [];
    for (var y = 4; y < sh - 4; y++) for (var xx = 4; xx < sw - 4; xx++) {
      var v = L[y*sw + xx]; if (v < 175) continue;
      var max = true, ring = 0, n = 0;
      for (var dy = -1; dy <= 1 && max; dy++) for (var dx = -1; dx <= 1; dx++) { if ((dx || dy) && L[(y+dy)*sw + xx+dx] > v) { max = false; break; } }
      if (!max) continue;
      for (var k = -4; k <= 4; k++) { ring += L[(y-4)*sw + xx+k] + L[(y+4)*sw + xx+k] + L[(y+k)*sw + xx-4] + L[(y+k)*sw + xx+4]; n += 4; }
      ring /= n;
      if (v - ring > 55) out.push({ x: xx / sw, y: y / sh, b: Math.min(1, (v - ring) / 140) });
    }
    out.sort(function(a, b){ return b.b - a.b; });
    return out.slice(0, 110);
  }
  function random(){ var a = []; for (var i = 0; i < 70; i++) a.push({ x: Math.random(), y: Math.random() * .75, b: .3 + Math.random() * .7 }); return a; }
  function init(hero){
    var media = hero.querySelector('.otxl-hero__media'); if (!media || media.querySelector('.otxl-stars-fx')) return;
    var img = media.querySelector('img'); if (!img) return;
    var go = function(){
      var pts = detect(img); if (!pts || !pts.length) pts = random();
      var cv = document.createElement('canvas'); cv.className = 'otxl-stars-fx';
      var anchor = img.closest('picture') || img; anchor.parentNode.insertBefore(cv, anchor.nextSibling);
      var ctx = cv.getContext('2d'), dpr = Math.min(2, window.devicePixelRatio || 1), W = 0, H = 0, vis = true;
      var stars = pts.map(function(p){ return { x: p.x, y: p.y, b: p.b, ph: Math.random() * 6.28, sp: .5 + Math.random() * 1.3, r: 1.1 + p.b * 2.2, flare: p.b > .7 && Math.random() > .35 }; });
      var size = function(){ var r = media.getBoundingClientRect(); W = r.width; H = r.height; cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr); };
      size(); if (window.ResizeObserver) new ResizeObserver(size).observe(media);
      new IntersectionObserver(function(es){ vis = es[0].isIntersecting; }).observe(hero);
      var iw = img.naturalWidth, ih = img.naturalHeight;
      var draw = function(t){
        requestAnimationFrame(draw);
        if (!vis || !W) return;
        t /= 1000;
        var k = Math.max(W / iw, H / ih), ox = (W - iw * k) / 2, oy = (H - ih * k) / 2;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, W, H);
        for (var i = 0; i < stars.length; i++) {
          var s = stars[i];
          var tw = Math.sin(t * s.sp + s.ph); tw = tw > 0 ? Math.pow(tw, 4) : 0;
          if (tw < .02) continue;
          var px = ox + s.x * iw * k, py = oy + s.y * ih * k, a = tw * (.45 + s.b * .55), r = s.r * (0.7 + tw * .6);
          var g = ctx.createRadialGradient(px, py, 0, px, py, r * 4);
          g.addColorStop(0, 'rgba(255,255,255,' + a + ')'); g.addColorStop(.25, 'rgba(255,255,255,' + a * .5 + ')'); g.addColorStop(1, 'rgba(255,255,255,0)');
          ctx.fillStyle = g; ctx.beginPath(); ctx.arc(px, py, r * 4, 0, 6.283); ctx.fill();
          if (s.flare) {
            var len = r * (2.4 + tw * 2.6);
            ctx.strokeStyle = 'rgba(255,255,255,' + a * .5 + ')'; ctx.lineWidth = .6;
            ctx.beginPath(); ctx.moveTo(px - len, py); ctx.lineTo(px + len, py); ctx.moveTo(px, py - len); ctx.lineTo(px, py + len); ctx.stroke();
          }
        }
      };
      requestAnimationFrame(draw);
      setTimeout(function(){ cv.classList.add('is-on'); }, 900);
    };
    if (img.complete && img.naturalWidth) go(); else img.addEventListener('load', go, { once: true });
  }
  var boot = function(){ document.querySelectorAll('.otxl [data-hero]').forEach(init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
